import get from 'lodash/get';

export const extractUpdates = payload => {
  const edges = get(payload, 'allWordpressPost.edges', []);
  return edges.map(edge => edge.node);
};
